import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const DEPLOYMENT_API_KEY = 'deployment';

export interface DeploymentOauthConfig {
  domain: string;
  sso_domain_provider_map: Record<string, string>;
  sso_otp_domain_allowlist: string[];
}

export interface CognitoDeploymentResponse {
  region: string;
  userPoolId: string;
  clientId: string;
  oauth?: DeploymentOauthConfig;
}

export interface DeploymentApiResponse {
  apiUrlPrefix?: string;
  newApiUrlPrefix?: string;
  postHogApiKey?: string;
  postHogApiHost?: string;
  /** AWS WAF CAPTCHA API key from runtime deployment config (optional per env). */
  wafCaptchaApiKey?: string;
  /** AWS WAF CAPTCHA SDK script URL from runtime deployment config (optional per env). */
  wafCaptchaSdkUrl?: string;
}

export const deploymentApi = createApi({
  reducerPath: DEPLOYMENT_API_KEY,
  baseQuery: fetchBaseQuery({
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    baseUrl: `/${DEPLOYMENT_API_KEY}`,
  }),
  endpoints: (builder) => ({
    fetchAPIPrefix: builder.query<DeploymentApiResponse, void>({
      query: () => ({
        url: 'api', //?hostname=${window.location.hostname}
        method: 'GET',
      }),
    }),
    fetchStripeKey: builder.query<any, void>({
      query: () => ({
        url: 'stripe', //?hostname=${window.location.hostname}
        method: 'GET',
      }),
    }),
    fetchCognito: builder.query<CognitoDeploymentResponse, void>({
      query: () => ({
        url: 'cognito', //?hostname=${window.location.hostname}
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchAPIPrefixQuery, useFetchStripeKeyQuery, useFetchCognitoQuery } =
  deploymentApi;
